module.exports = __webpack_public_path__ + "static/joey_bream-81db0e4a39411055c77344df0e258578.png";